export default "__VITE_ASSET__dJ$ULFcuzX43djbIEsCZPw__ 480w, __VITE_ASSET__ykb1zIozoJBMq4UvQnlhcQ__ 768w, __VITE_ASSET__BjjUHagISQHtPWYmu3KuwQ__ 1200w";